import { DEFAULT_IMAGEKIT_THUMBNAIL_CONFIG, ImageKitThumbnailConfig } from '@groundworks/ngx-groundworks-ui';
import { ConfigService } from '../config.service';

export function ImageKitThumbnailConfigFactory(config: ConfigService): ImageKitThumbnailConfig {
  return { ...DEFAULT_IMAGEKIT_THUMBNAIL_CONFIG, hosts: config.imageKitHost ? [config.imageKitHost] : [] };
}
